import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq",
  "use": "icon-seq-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-seq\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M21,3H3A1,1,0,0,0,2,4V20a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V4A1,1,0,0,0,21,3ZM20,19H4V5H20ZM9,14H7V10H9Zm8,0H15V10h2Zm-6,.28V9.72A2,2,0,0,1,10,8a2,2,0,0,1,4,0,2,2,0,0,1-1,1.72v4.56A2,2,0,0,1,14,16a2,2,0,0,1-4,0A2,2,0,0,1,11,14.28Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol